module.exports = __webpack_public_path__ + "static/media/icon-clock.ccaa4a94.svg";